export default class HelperMask {
  static removeCepMask = (cep: string): string => cep.replace(/\D/g, "");

  static removeCpfMask = (cpf: string): string => cpf.replace(/\D/g, "");

  static removePhoneMask = (phone: string): string => phone.replace(/\D/g, "");

  static removeCnpjMask = (cnpj: string): string =>
    cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();

  static applyCnpjMask = (cnpj: string): string => {
    if (!cnpj) return "";
    const raw = HelperMask.removeCnpjMask(cnpj);
    if (raw.length !== 14) return cnpj;
    return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12, 14)}`;
  };
}
